export default "__VITE_ASSET__Cwjn$9$q__"